<template>
	<div
		class="m-4 flex max-w-full items-center justify-between border-b border-slate-100 pb-2 text-xs text-slate-500 italic"
	>
		<slot></slot>
	</div>
</template>

<script setup lang="ts"></script>
